<template>
  <div class="card my-3" style="width: 30rem">
    <div class="remove" v-if="isUserPosts" @click="deletePost">
      <i class="fas fa-trash remove-icon"></i>
    </div>
    <img class="card-img-top" :src="post.blogCoverPhoto" alt="Card image cap" />
    <div class="card-body">
      <p class="card-text">
        {{ post.blogTitle }}
      </p>
      <p class="card-date">
        Posted on:
        {{
          new Date(post.blogDate).toLocaleString("en-us", { dateStyle: "long" })
        }}
      </p>
      <router-link
        :to="{ name: 'SingleBlog', params: { blogid: this.post.blogID } }"
        class="router-text"
        >View the Post -></router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  components: {},
  props: ["post", "number", "isUserPosts"],
  data() {
    return {};
  },
  methods: {
    deletePost() {
      if (window.confirm("Do you want to delete this blog")) {
        this.$store.dispatch("deletePost", this.post.blogID);
      }
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 12px;
}
.remove-icon {
  font-size: 18px;
  align-self: center;
  color: #eeeeee;
}
.remove-icon:hover {
  color: #b14b4b;
}
.card:hover {
  transition: all 0.5s ease;
  transform: rotate(-2deg);
  cursor: pointer;
}
.router-text {
  font-size: 16px;
  color: black;
}
.card-img-top {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.router-text:hover {
  text-decoration: none;
  font-size: 16px;
  color: #1eb8b8;
}
.card-text {
  font-size: 18px;
  font-weight: bold;
}
.card-date {
  font-size: 14px;
}
.remove {
  width: 40px;
  height: 40px;
  background-color: #303030;
  position: absolute;
  margin-right: 10px;
  right: 10px;
  top: 10px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
}
</style>
